module.exports = __webpack_public_path__ + "static/media/Paypal.3c6bc24d.jpg";